"use strict";
exports.__esModule = true;
exports.LOAN_APPLICATION = void 0;
var LOAN_APPLICATION = {
    CIRCUMSTANCE_CHANGES: {
        AFFORDABILITY_CHANGES: {
            ANTICIPATED_EVENT: {
                PERMANENT_INCOME_REDUCTION: 'permanent_income_reduction',
                TEMPORARY_INCOME_REDUCTION: 'temporary_income_reduction',
                PERMANENT_EXPENDITURE_REDUCTION: 'permanent_expenditure_increase',
                TEMPORARY_EXPENDITURE_REDUCTION: 'temporary_expenditure_increase',
                ONE_OFF_LARGE_EXPENDITURE: 'one_off_large_expenditure',
                NONE: 'none'
            },
            ADAPTATION_PLAN: {
                APPLICATION_REFLECTS_CHANGES: 'application_reflects_changes',
                EXPENDITURE_REDUCE: 'expenditure_reduce',
                USE_SAVINGS: 'use_savings',
                ADDITIONAL_INCOME: 'additional_income',
                NONE: 'none'
            }
        }
    },
    DATA_RETRIEVAL: {
        STATUS: {
            GENERATED: 'generated',
            STARTED: 'started',
            COMPLETED: 'completed'
        },
        ACCESS_METHOD: {
            OPEN_LINK: 'open_link',
            SEND_EMAIL: 'send_email'
        }
    },
    INTENT: {
        LOAN_PURPOSE: {
            PURCHASE: 'purchase',
            REFINANCE: 'refinance'
        },
        PROPERTY_PURPOSE: {
            INVESTMENT: 'investment',
            LIVING: 'living'
        }
    },
    STRUCTURE: {
        LOAN_FLEXIBILITY_PREFERENCE: {
            VALID_RANGE: [1, 2, 3, 4, 5]
        },
        FIXED_LOAN_RATE_TERM: {
            VALID_RANGE: [0.5, 1, 2, 3, 4, 5]
        },
        LOAN_RATE_TYPE: {
            FIXED: 'fixed',
            FLOATING: 'floating',
            FIXED_AND_FLOATING: 'fixed_and_floating'
        },
        REPAYMENT_TYPE: {
            INTEREST_ONLY: 'interest_only',
            INTEREST_AND_PRINCIPAL: 'interest_and_principal',
            LINE_OF_CREDIT: 'line_of_credit',
            NONE: 'none'
        }
    },
    STAGES: {
        DRAFT: 'draft',
        AWAITING_AFFORDABILITY_LINK: 'awaiting_affordability_linking',
        PENDING_BROKER: 'pending_broker',
        SUBMITTED: 'submitted',
        AFFORDABILITY_PRE_APPROVED: 'affordability_pre_approved',
        AFFORDABILITY_APPROVED: 'affordability_approved',
        PRE_APPROVED: 'pre_approved',
        PROPERTY_SUBMITTED: 'property_submitted',
        PROPERTY_PRE_APPROVED: 'property_pre_approved',
        PROPERTY_APPROVED: 'property_approved',
        PROPERTY_REJECTED: 'property_rejected',
        AWAITING_CREDIT_DESCISION: 'awaiting_credit_descision',
        CONDITIONAL_OFFER: 'conditional_offer',
        AWAITING_BUILDING_REPORT: 'awaiting_building_report',
        AWAITING_PHYSICAL_VALUATION: 'awaiting_physical_valuation',
        UNCONDITIONAL_OFFER: 'unconditional_offer',
        AWAITING_LOAN_STRUCTURE_PREFERENCE: 'awaiting_loan_structure_preference',
        TERMS_AGREED: 'terms_agreed',
        WITH_SOLICITOR: 'with_solicitor',
        SOLICITOR_SIGN_OFF: 'solicitor_sign_off',
        LOAN_INFO_SNAPSHOT: 'loan_info_snapshot',
        AWAITING_SETTLEMENT: 'awaiting_settlement',
        FUNDS_DRAWN_DOWN: 'funds_drawn_down',
        SETTLEMENT_COMPLETE: 'settlement_complete',
        LOAN_COMPLETE: 'loan_complete',
        REJECTED: 'rejected'
    },
    OUTCOMES: {
        APPROVED: 'approved',
        REJECTED: 'rejected'
    }
};
exports.LOAN_APPLICATION = LOAN_APPLICATION;
